module.exports = __webpack_public_path__ + "img/industry4_m.f9bee7cc.jpg";